import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keys'
})
export class KeysPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return Object.keys(value);
  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/keys.pipe.ts